import React from "react";
import "./AILabel.scss";
import { useIcon } from "../../assets/useIcon";
import Label, { LabelVariant } from "../Label/Label";

type AILabelProps = {
  loading?: boolean;
  loadingText?: string;
  error?: string;
  aiText?: string;
  isGeneratedByAi?: boolean;
  generatedByAiText?: string;
  generatedByAiTextWithWarning?: boolean;
  showBetaLabel?: boolean;
  animateStars?: boolean;
};

const AILabel: React.FC<AILabelProps> = ({
  loading,
  loadingText,
  error,
  aiText,
  isGeneratedByAi,
  generatedByAiText,
  generatedByAiTextWithWarning,
  showBetaLabel = false,
  animateStars = false,
}) => {
  const { getSvg } = useIcon();
  return (
    <div className={`seem-ai-generated-row-indicator `}>
      <img
        src={getSvg("icon-ai") as string}
        alt="Seemplicity AI"
        className={`seem-ai-generated-row-indicator-icon ${animateStars ? "animate-stars" : ""}`}
      />
      <span
        className={`seem-ai-generated-row-indicator-label ${
          loading ? "is-loading" : ""
        } ${error ? "is-error" : ""} ${
          generatedByAiTextWithWarning ? "is-warning" : ""
        }`}
      >
        {loading
          ? loadingText || "Seemplicity AI is at work"
          : error
            ? error
            : isGeneratedByAi
              ? generatedByAiText || "Generated by the Seemplicity AI"
              : aiText || "Try out Seemplicity AI's optimized results"}
      </span>
      {loading && (
        <div className={"dots-inline-loader-container"}>
          <div className="dots-inline-loader" />
        </div>
      )}
      {!loading && showBetaLabel && (
        <Label
          text="Beta"
          variant={LabelVariant.Outlined}
          className="ai-beta-label"
        />
      )}
    </div>
  );
};

export default AILabel;
